import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Constants } from 'uApp/app.constants';

@Injectable({
  providedIn: 'root'
})
export class FakeService {
  public fakeOn: boolean;

  constructor(private http: HttpClient) {
    this.fakeOn = Constants.FAKE_DATA_ON; }

  public getFakeData(fileName: string): Observable<any> {
    return this.http.get('./assets/sample-data/' + fileName + '.json');
  }
}
